import PropTypes from 'prop-types'

const BigDataAnalytics = ({ className, classNames }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="221"
    height="122"
    viewBox="0 0 221 122"
  >
    <defs>
      <linearGradient id="data-cloud-a" x1="12.453%" x2="87.895%" y1="84.924%" y2="16.33%">
        <stop offset="0%" stopColor="#1D8DBA" />
        <stop offset="100%" stopColor="#03ECAE" />
      </linearGradient>
      <path
        id="data-cloud-c"
        d="M43.905,42.1415 C43.905,43.694 42.6435,44.9555 41.094,44.9555 C39.5385,44.9555 38.277,43.694 38.277,42.1415 C38.277,40.589 39.5385,39.3275 41.094,39.3275 C42.6435,39.3275 43.905,40.589 43.905,42.1415 Z"
      />
      <filter
        id="data-cloud-b"
        width="277.7%"
        height="277.7%"
        x="-88.8%"
        y="-71.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.236752717 0"
        />
      </filter>
      <path
        id="data-cloud-e"
        d="M28.0515,10.424 C28.0515,11.9765 26.79,13.235 25.2405,13.235 C23.685,13.235 22.4235,11.9765 22.4235,10.424 C22.4235,8.8685 23.685,7.61 25.2405,7.61 C26.79,7.61 28.0515,8.8685 28.0515,10.424 Z"
      />
      <filter
        id="data-cloud-d"
        width="277.7%"
        height="277.8%"
        x="-88.8%"
        y="-71.1%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.236752717 0"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-6)">
      <image
        width="227.856"
        height="120.129"
        x="0.521"
        y="1.587"
        xlinkHref="/images/clouds/data-cloud.png"
      />
      <g transform="translate(68.833 .126)">
        <g className={classNames.pieGraph} fillRule="nonzero" transform="translate(67 57)">
          <path
            fill="#48A7C7"
            d="M11.7485,22.503 C5.537,22.503 0.5,17.4645 0.5,11.253 C0.5,5.037 5.537,0.0015 11.7485,0.0015 L11.7485,22.503 Z"
          />
          <path
            fill="#1883A6"
            d="M11.7485,11.253 L11.7485,22.503 C17.96,22.503 22.9985,17.4645 22.9985,11.253 L22.9985,11.2485 L11.7485,11.253 Z"
          />
          <path
            fill="#1B92B9"
            d="M11.7485,11.2485 L11.7485,0.0015 C14.8535,0.0015 17.6645,1.26 19.7015,3.2925 L11.7485,11.2485 Z"
          />
          <path
            fill="#157494"
            d="M11.7485,11.2485 L19.7015,3.2925 C21.737,5.328 22.9985,8.1405 22.9985,11.2485 L11.7485,11.2485 Z"
          />
        </g>
        <g className={classNames.circleGraph} fillRule="nonzero" transform="translate(22)">
          <path
            fill="#04EAAE"
            fillOpacity="0.1"
            d="M41.7515 43.7385L41.753 43.7415C46.3475 39.621 49.256 33.6585 49.256 26.9985L45.5045 26.9985C45.5045 33.6585 42.596 39.621 38.0015 43.7415L38.0015 49.4985 41.7515 49.4985 41.7515 43.7385zM23.0045 4.836L23.0045 13.8735C19.3775 13.8735 16.097 15.3435 13.724 17.7165 11.3465 20.094 9.8795 23.376 9.8795 26.9985 9.8795 29.8095 10.8065 32.37 12.3155 34.5L16.0625 34.5C14.5535 32.37 13.6265 29.8095 13.6265 26.9985 13.6265 23.376 15.095 20.094 17.471 17.7165 19.844 15.345 23.126 13.8735 26.753 13.8735L26.753 4.497C25.472 4.4985 24.2255 4.632 23.0045 4.836z"
          />
          <path
            fill="#03BB8B"
            d="M36.128,26.9985 C36.128,30.0525 35.042,32.823 33.296,35.055 C36.0455,36.168 38.0015,38.8635 38.0015,42 L38.0015,43.7415 C42.596,39.621 45.5045,33.6585 45.5045,26.9985 L36.128,26.9985 Z"
          />
          <path
            fill="#1DECB6"
            d="M9.8795,26.9985 C9.8795,23.376 11.348,20.094 13.724,17.7165 L7.0955,11.0895 C3.023,15.162 0.503,20.787 0.503,26.9985 L9.8795,26.9985 Z"
          />
          <path
            fill="#03D29C"
            d="M23.0045,13.875 C19.3775,13.875 16.097,15.345 13.724,17.718 L7.0955,11.091 C11.165,7.0185 16.79,4.4985 23.0045,4.4985 L23.0045,13.875 Z"
          />
          <path
            fill="#04EAAE"
            fillOpacity="0.224"
            d="M12.3155,34.5 C10.8065,32.37 9.8795,29.8095 9.8795,26.9985 L0.5045,26.9985 C0.5045,29.634 0.9875,32.151 1.817,34.5 L12.3155,34.5 Z"
          />
          <path
            fill="url(#data-cloud-a)"
            d="M49.2515,23.2515 C49.2515,10.8225 39.179,0.7515 26.7515,0.7515 L26.7515,10.125 C33.9965,10.125 39.878,16.0005 39.878,23.25 L49.2515,23.25 L49.2515,23.2515 Z"
          />
        </g>
        <g className={classNames.lineGraph} transform="translate(0 34)">
          <path
            fill="#04EAAE"
            fillRule="nonzero"
            stroke="#145186"
            strokeOpacity="0.229"
            strokeWidth="1.125"
            d="M59.433,53.2905554 L59.433,27.494 C57.2181419,27.494 57.1594056,27.494 56.352,27.494 C56.0077968,27.494 55.6896448,27.6261554 55.4459759,27.8590114 C55.3222502,27.9816421 55.2219068,28.125223 55.1572949,28.2669872 L53.5982277,32.0355402 C53.4689445,32.3188224 53.2912801,32.574215 53.0626907,32.8026027 C52.6068283,33.2383831 52.0102269,33.4865 51.372,33.4865 C50.9034373,33.4865 50.9034373,33.4865 49.4977491,33.4865 C48.794343,33.4865 48.794343,33.4865 48.2083588,33.4865 C47.9593999,33.4865 47.9593999,33.4865 47.7838297,33.4865 C47.7125571,33.4865 47.7125571,33.4865 47.6651358,33.4865 C47.6462413,33.4865 47.6462413,33.4865 47.6339976,33.4865 C47.6291658,33.4865 47.6291658,33.4865 47.6260827,33.4865 C47.6248744,33.4865 47.6248744,33.4865 47.6241141,33.4865 C47.6238186,33.4865 47.6238186,33.4865 47.6236364,33.4865 C47.6235666,33.4865 47.6235666,33.4865 47.6235254,33.4865 L47.6235,32.3615 L47.6235,33.4865 C47.2786139,33.4865 46.9579754,33.6191874 46.7192476,33.8482476 C46.591132,33.9763631 46.4909479,34.1195993 46.4285736,34.2600215 C46.3316628,34.4936515 46.3316628,34.4936515 45.9439909,35.4284998 C45.58055,36.3049969 45.2171098,37.181751 44.8779031,38.0004068 C44.8766146,38.0035163 44.8766146,38.0035163 44.8753262,38.0066258 C44.4883797,38.9405012 44.1589884,39.7359798 43.9039337,40.3526497 C44.2646586,40.8993626 44.463,41.4995826 44.463,42.14 C44.463,44.0026028 42.9502172,45.5165 41.0895,45.5165 C39.2238967,45.5165 37.71,44.0037168 37.71,42.14 C37.71,41.5009961 37.9102376,40.9002989 38.2716294,40.355016 L27.0502238,13.2563922 C26.5166961,13.6046968 25.8932966,13.7975 25.2375,13.7975 C24.5795978,13.7975 23.9558408,13.6040144 23.4214235,13.2540293 L16.2656307,30.5293438 C16.1358192,30.8118749 15.9579501,31.0680451 15.7306907,31.2951027 C15.2749733,31.7307445 14.6781811,31.9775 14.037,31.9775 L10.2885,31.9775 C9.94472992,31.9775 9.62387348,32.1108252 9.38599588,32.3389915 C9.25652093,32.4696123 9.15624713,32.6127057 9.09370626,32.7522014 L5.97881598,40.2731845 C5.84591678,40.5582436 5.66686684,40.8154156 5.44644243,41.0319543 C4.99283229,41.4715146 4.39330378,41.72 3.7485,41.72 L0.564,41.72 L0.564,53.0015 C0.564,56.8150898 3.68641017,59.9375 7.5015,59.9375 L52.5,59.9375 C56.2185445,59.9375 59.2799525,56.9713156 59.433,53.2905554 Z"
          />
          <path
            fill="url(#data-cloud-a)"
            fillRule="nonzero"
            d="M0.0015,41.156 L3.7485,41.156 C4.26,41.156 4.716,40.955 5.055,40.6265 C5.226,40.4585 5.3655,40.256 5.469,40.034 L8.574,32.5355 C8.6745,32.3105 8.817,32.1125 8.9865,31.9415 C9.3255,31.616 9.7815,31.4135 10.2885,31.4135 L14.037,31.4135 C14.547,31.4135 15.0015,31.2125 15.342,30.887 C15.513,30.716 15.6525,30.515 15.7545,30.293 L23.1945,12.3305 C22.725,11.8265 22.4205,11.1635 22.4205,10.4225 C22.4205,8.867 23.682,7.6085 25.2375,7.6085 C26.787,7.6085 28.0485,8.867 28.0485,10.4225 C28.0485,11.1665 27.7485,11.8295 27.2775,12.3335 L38.9115,40.4285 C39.426,39.773 40.191,39.3245 41.0895,39.3245 C41.9835,39.3245 42.747,39.7745 43.2645,40.4255 C44.127,38.339 45.909,34.043 45.909,34.043 C46.008,33.8195 46.1505,33.62 46.3215,33.449 C46.6605,33.1235 47.1165,32.9225 47.6235,32.9225 C47.6205,32.9225 51.372,32.9225 51.372,32.9225 C51.879,32.9225 52.3335,32.72 52.674,32.3945 C52.845,32.2235 52.9845,32.024 53.0865,31.8005 L54.6375,28.0505 C54.7395,27.8255 54.8805,27.626 55.05,27.458 C55.392,27.131 55.845,26.93 56.352,26.93 C56.352,26.93 58.0935,26.93 59.9955,26.93 L59.9955,8 C59.9955,3.8735 56.6205,0.5 52.494,0.5 L7.5015,0.5 C3.375,0.5 0.0015,3.8735 0.0015,8 L0.0015,41.156 Z"
          />
          <path d="M60.0015,53.0015 C60.0015,57.125 56.6265,60.5 52.5,60.5 L7.5015,60.5 C3.375,60.5 0.0015,57.125 0.0015,53.0015 L0.0015,8 C0.0015,3.8735 3.3765,0.5 7.5015,0.5 L52.5,0.5 C56.6265,0.5 60.0015,3.8735 60.0015,8 L60.0015,53.0015 Z" />
          <path
            stroke="#4A5D72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.125"
            d="M30.78,47.7665 C30.78,48.8015 31.623,49.643 32.655,49.643 C33.6885,49.643 34.5315,48.8015 34.5315,47.7665 L34.5315,44.021 C34.5315,42.9845 33.6885,42.1445 32.655,42.1445 C31.623,42.1445 30.78,42.9845 30.78,44.021 L30.78,47.7665 Z"
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.125"
            d="M40.2345,16.049 C40.2345,17.084 41.076,17.921 42.111,17.921 C43.143,17.921 43.9815,17.084 43.9815,16.049 L43.9815,12.299 C43.9815,11.267 43.143,10.424 42.108,10.424 C41.076,10.424 40.2345,11.267 40.2345,12.299 L40.2345,16.049 Z"
          />
          <polygon
            stroke="#4A5D72"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.125"
            points="27.968 49.643 27.968 42.145 26.093 44.021 27.968 42.145"
          />
          <path
            stroke="#FFF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.125"
            d="M33.675,16.049 C33.675,17.084 34.515,17.921 35.55,17.921 C36.5835,17.921 37.4235,17.084 37.4235,16.049 L37.4235,15.11 C37.4235,14.078 36.5835,13.238 35.5485,13.238 L33.675,13.238 L33.672,10.424 L37.4235,10.424 L33.672,10.424 L33.675,13.238 L35.5485,13.238 C36.5835,13.238 37.4235,14.078 37.4235,15.11 L37.4235,16.049 C37.4235,17.084 36.5835,17.921 35.55,17.921 C34.515,17.921 33.675,17.0855 33.675,16.049 Z"
          />
          <g fillRule="nonzero">
            <use fill="#000" filter="url(#data-cloud-b)" xlinkHref="#data-cloud-c" />
            <use fill="#329DC0" xlinkHref="#data-cloud-c" />
          </g>
          <g fillRule="nonzero">
            <use fill="#000" filter="url(#data-cloud-d)" xlinkHref="#data-cloud-e" />
            <use fill="#329DC0" xlinkHref="#data-cloud-e" />
          </g>
        </g>
      </g>
      <polygon
        fill="url(#data-cloud-a)"
        points="58.575 42.418 46.674 40.796 24.082 63.845 46.035 45.06 54.453 45.06"
      />
      <polygon
        fill="url(#data-cloud-a)"
        points="161.771 83.368 186.387 76.325 201.628 46.618 186.387 83.368"
      />
    </g>
  </svg>
)

BigDataAnalytics.defaultProps = {
  className: '',
  classNames: {
    pieGraph: 'pieGraph',
    circleGraph: 'circleGraph',
    lineGraph: 'lineGraph',
  },
}

BigDataAnalytics.propTypes = {
  className: PropTypes.string,
  classNames: PropTypes.shape({
    pieGraph: PropTypes.string,
    circleGraph: PropTypes.string,
    lineGraph: PropTypes.string,
  }),
}

export default BigDataAnalytics
